/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, total: NonNullable<unknown> }} Calibration_Temperature_SyncedInputs */



/**
* | output |
* | --- |
* | "The calibration setting is being synchronized with the th. heads ({count}/{total})" |
*
* @param {Calibration_Temperature_SyncedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const calibration_temperature_synced = /** @type {((inputs: Calibration_Temperature_SyncedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calibration_Temperature_SyncedInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`The calibration setting is being synchronized with the th. heads (${i?.count}/${i?.total})`)
	return /** @type {LocalizedString} */ (`Le réglage de calibrage est en cours de synchronisation avec les têtes (${i?.count}/${i?.total})`)
});